<i18n lang="yaml">
en:
  header: SSH Keys
  ssh_key: Public SSH Key
  key_name: Key Name
  add_ssh_key: Add SSH Key
  key_material: Key Material
ru:
  header: Ключи SSH
  ssh_key: Публичный SSH ключ
  key_name: Имя ключа
  add_ssh_key: Добавить SSH ключ
  key_material: Материал ключа
</i18n>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<template>
  <div class="card">
    <h4 class="card-header">
      {{ t('header') }}
      <div class="float-end">
        <router-link
          :to="{ name: 'account:keys:gitlab' }"
          class="card-button btn btn-outline-secondary"
        >
          <img src="@/assets/gitlab.svg" />
        </router-link>
        <router-link
          :to="{ name: 'account:keys:github' }"
          class="card-button btn btn-outline-secondary"
        >
          <img src="@/assets/github.svg" />
        </router-link>
        <router-link
          :to="{ name: 'account:keys:add' }"
          class="card-button btn btn-outline-secondary"
        >
          <img class="filter" src="@/assets/plus.svg" />
        </router-link>
        <router-link
          :to="{ name: 'account:keys:list' }"
          class="card-button btn btn-outline-secondary"
        >
          <img class="filter" src="@/assets/list-unordered.svg" />
        </router-link>
      </div>
    </h4>
    <router-view />
  </div>
</template>

<style scoped>
.card-button {
  border: 0;
}

.active {
  background-color: transparent;
}

.router-link-exact-active {
  background-color: #6c757d;
}
</style>
